export default {
    messages: {
        type: Object,
        default: undefined
    },
    user: {
        type: Object,
        default: undefined
    },
    toolbar: {
        type: Object,
        default: undefined
    },

    // Events
    actionClick: {
        type: Function,
        default: undefined
    }, 
    post: {
        type: Function,
        default: undefined
    }, 
    sendMessage: {
        type: Function,
        default: undefined
    }, 
    typingEnd: {
        type: Function,
        default: undefined
    }, 
    typingStart: {
        type: Function,
        default: undefined
    }, 
    toolClick: {
        type: Function,
        default: undefined
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-chat-vue-wrapper/src/KendoChat/ChatProps.js